/**
 * The one thing a guest is told, and it is told once per screen rather than as a dialog.
 *
 * A guest's matches are on this device and nowhere else, which is precisely what ADR-0008
 * says an account exists to fix. So the banner is not an upsell in the marketing sense — it
 * names a real consequence ("this phone only") and offers the fix.
 *
 * Never over the pad. `main.tsx` withholds it on the scoring screen, for the reason the tab
 * bar is withheld: nothing lives in the loop that is not the loop.
 */

interface Props {
  readonly onSignUp: () => void;
}

export function GuestBanner({ onSignUp }: Props): React.ReactElement {
  return (
    <div className="guest-banner" role="status">
      <span>Scoring as a guest — this phone only</span>
      <button className="ds-btn ds-btn--primary ds-btn--sm" onClick={onSignUp}>
        Sign up to keep your matches
      </button>
    </div>
  );
}
